<template>
<div>
    
</div>
</template>

<script>
import axios from "axios";

export default {
  name: 'signIn',
  props: {
    profileId: 
    {
     type: String,
    required: true
  }
},
data()
{
    return{
        "awardeeId":null
        
       
    }
},
async mounted()
{
    this.awardeeId = this.profileId;

 //get token from local storage 
    //redirect if absent
    //make graphql mutation call to api
    //get response and redirect to home using router
   //get user access token
    let token = localStorage.getItem("token");

    try
    {
       if((token == "noToken") || (token == null))
    {
      alert("Ilegal page view");
      return this.$router.push("/timeawards/");
    }
   


  //CHECK IF USER TOKEN IS VALID
  let userDataResponse = await axios({
       method: "get",
       url: "https://time-person-mofe.herokuapp.com/api/dashboard/profile",
       headers: {"Authorization": "Bearer "+token}
     });

    let requestStatus = userDataResponse.data.status;

    if(requestStatus != "success")
    {
      this.$router.push("/timeawards/");
      
    }


     let DataResponse = await axios({
       method: "get",
       url: `https://time-person-mofe.herokuapp.com/api/deleteProfile/${this.awardeeId}`,
       headers: {"Authorization": "Bearer "+token}
     });

     if(DataResponse.data.data.status == "success")
      {
        alert(DataResponse.data.data.message);
         this.$router.push("/timeawards/");
      }
      else{
        alert(DataResponse.data.data.message);
         this.$router.push("/timeawards/");
      }

    }
    catch(error)
    {
       this.$router.push("/timeawards/");
    }
   
    
    
}
,
methods:
{
    passwordHandler: function(e)
    {
        let passwordValue = e.target.value;
        this.password = passwordValue;
    },
    emailHandler: function(e)
    {
        let emailValue = e.target.value;
        this.email = emailValue;
    },
    handleSubmit: async function ()
    {
       // e.preventDefault;
        if((this.email != null) && (this.password != null))
        {
            //make axios call
          alert(this.email +" "+ this.password);
        }
        else
        {
            alert("Please fill form properly before submitting");
        }
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
